import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/decorative/sidebar-circles.svg")